
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28713",
  depVersions: {
  "payments-ui-app": "static-1.28713",
  "bend-plugin-arboretum": "static-1.2021",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.511",
  "crm_data": "static-4.93214",
  "data-fetching-client": "static-1.10118",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8755",
  "foundations-components-legacy": "static-1.1780",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6070",
  "hs-test-utils": "static-1.8516",
  "hub-http": "static-1.6684",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11965",
  "I18n": "static-7.1708",
  "jasmine-runner": "static-1.6929",
  "quartz": "static-1.7660",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5658",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6102",
  "UIComponents": "static-3.8911",
  "usage-tracker-public": "static-1.7613",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38062",
  "payments-checkout-lib": "static-1.636",
  "cssUtils": "static-1.1100",
  "customer-data-objects": "static-1.8182",
  "FireAlarmUi": "static-1.4867",
  "foundations-assets": "static-1.5363",
  "foundations-theming": "static-1.4966",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12272",
  "icons": "static-2.703",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3363",
  "property-translator": "static-1.5858",
  "quartz-config": "static-1.1438",
  "quartz-core": "static-1.6879",
  "quartz-i18n": "static-1.1335",
  "quartz-routing": "static-1.1090",
  "quartz-tracking": "static-1.1039",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17215",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10848",
  "rpc-client-utils": "static-1.5147",
  "sanitize-text": "static-1.8636",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5237",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11623",
  "ui-images": "static-2.1277",
  "usage-tracker-core": "static-1.7652",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3937",
  "quartz-webpack": "static-1.3884",
  "bend-plugin-quartz-routing": "static-1.738",
  "bender-build-tools": "static-1.3600",
  "crm_universal": "static-1.22733",
  "customer-data-email": "static-1.18649",
  "customer-data-ui-utilities": "static-1.10309",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8398",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8241",
  "quick-fetch": "static-1.4233",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5024",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2682",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9905",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3095",
  "ui-fonts": "static-1.1227",
  "HeadJS": "static-2.822",
  "hs-test-utils-bend-plugin": "static-1.3627",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.402",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4785",
  "foundations-components-test-utils": "static-1.6238",
  "ui-addon-draggable": "static-3.5226",
  "commerce-billing-lib": "static-1.20499",
  "commerce-shared-components-lib": "static-1.19573",
  "commerce-tools-ui-lib": "static-1.11330",
  "crm-message-bus": "static-1.44114",
  "customer-data-objects-ui-components": "static-1.13514",
  "customer-data-properties": "static-1.53061",
  "growth-payments-core": "static-1.26510",
  "ui-addon-iframeable": "static-1.9553",
  "usage-tracker": "static-1.7802",
  "usage-tracker-container": "static-1.7792",
  "sassPrefix": "static-1.366",
  "inbound-db-properties-service-client": "static-1.4153",
  "foundations-theming-base": "static-1.3951",
  "bend-plugin-foundations-theming": "static-1.3449",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.269",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4977",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.644",
  "quartz-auth": "static-1.1335",
  "quartz-head": "static-1.1325",
  "quartz-test": "static-1.1335",
  "trellis-components": "static-1.3114",
  "usage-tracker-session-replay": "static-1.5488",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.178",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.557",
  "chirp-fetch": "static-1.2382",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4952",
  "FormUrlGenerator": "static-2.5190",
  "sequences-lib": "static-1.8794",
  "apollo-link-hub-http": "static-2.5065",
  "FileManagerCore": "static-1.40350",
  "FileManagerLib": "static-1.40491",
  "hubspot-apollo-client": "static-1.5359",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.735",
  "timezone-utils": "static-2.5707",
  "ui-gdpr-components": "static-1.10656",
  "react-dnd-compat": "static-1.5087",
  "stylex-utils": "static-1.175",
  "trellis-theming": "static-1.1485",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2963",
  "hs-resources": "static-1.667",
  "pulse": "static-1.1125",
  "utility-belt": "static-1.3015",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2026",
  "customer-data-associations": "static-1.7816",
  "customer-data-property-utils": "static-1.8529",
  "customer-data-tracking": "static-1.7348",
  "framework-data-schema-resolvers": "static-1.7370",
  "framework-data-table": "static-2.12846",
  "object-builder-ui-client": "static-1.50056",
  "payments-enrollment-embed-lib": "static-1.24213",
  "stripe-embedded-components": "static-1.8253",
  "ui-addon-opt": "static-4.8888",
  "ai-components-ui-library": "static-1.10028",
  "customer-data-rte": "static-1.33908",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24851",
  "growth-onboarding-confetti": "static-1.3536",
  "growth-onboarding-empty-states": "static-1.6542",
  "hubspot-prosemirror": "static-1.19287",
  "InboxConnectUtils": "static-4.15851",
  "payment-link-components": "static-1.24464",
  "payments-post-enroll-local-storage-lib": "static-1.5582",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39177",
  "react-colorpicker": "static-2.10687",
  "ui-addon-upgrades": "static-9.18547",
  "ui-addon-video-player": "static-1.9101",
  "user-context": "static-1.5531",
  "restore-request-side-panel-lib": "static-1.2034",
  "atom": "static-1.5550",
  "reference-resolvers": "static-1.8661",
  "calling-global-api": "static-1.66205",
  "calling-internal-common": "static-1.31803",
  "calling-lifecycle-internal": "static-1.67587",
  "calling-lifecycle-messages": "static-1.59879",
  "commerce-products-lib": "static-1.10927",
  "conditional-properties-service-client": "static-1.4115",
  "crm-index-visualization-core": "static-1.4763",
  "crm-links": "static-1.6790",
  "crm-pipelines-api-client-types": "static-1.4445",
  "customer-data-properties-shared-msw-handlers": "static-1.10239",
  "external-options-client-types": "static-1.4441",
  "formula-editor": "static-1.15018",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3776",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1109",
  "multi-currency-client-types": "static-1.4009",
  "pipeline-validation-client-types": "static-1.4283",
  "property-value-citations": "static-1.3675",
  "reference-resolvers-lite": "static-1.8591",
  "smart-data-capture-core": "static-1.482",
  "smart-property-lib": "static-1.8666",
  "tiered-pricing": "static-1.2286",
  "topics-actions-lib": "static-1.661",
  "trellis-ext-i18n": "static-1.1395",
  "trial-components-library": "static-1.14383",
  "ui-addon-form-validation": "static-1.11348",
  "laboratory-lib": "static-3.7624",
  "onboarding-scopes": "static-1.6930",
  "seat-types-lib": "static-1.1060",
  "magpie-lib": "static-1.5909",
  "navigation-messaging": "static-1.8502",
  "ts-schema": "static-1.4395",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10912",
  "hubspotter-http-shared-msw-handlers": "static-1.10910",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8651",
  "audio-components": "static-1.6577",
  "breeze-artifacts-sdk": "static-1.972",
  "ContentUtils": "static-1.69481",
  "copilot-toolkit": "static-1.12157",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30068",
  "FileManagerImages": "static-1.38002",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4619",
  "ui-universal-auth": "static-1.9753",
  "urlinator": "static-1.4992",
  "video-components": "static-1.14440",
  "video-data-lib": "static-1.36096",
  "video-embed": "static-1.36930",
  "hubspot-apollo-cache": "static-1.818",
  "trellis-migration-context": "static-1.58",
  "event-emitter": "static-1.1439",
  "fdsr-migration-layer": "static-1.489",
  "framework-builder-read-service-client": "static-1.4337",
  "bend-plugin-pulse": "static-1.628",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7275",
  "persist-promise": "static-1.4183",
  "customer-data-reference-ui-components": "static-1.13654",
  "reporting-data": "static-1.69361",
  "tasks-actions-lib": "static-1.440",
  "purchase-motions-components": "static-1.6636",
  "growth-onboarding-feedback-components": "static-1.7058",
  "growth-onboarding-reliability": "static-1.5561",
  "marketplace-ui-apps-core": "static-1.19582",
  "onboarding-tours": "static-1.17410",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23907",
  "content-assistance-lib": "static-1.8429",
  "draft-content-plugins": "static-1.29164",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22365",
  "rich-text-lib": "static-1.20562",
  "breeze-engine-lib": "static-1.2193",
  "poll-commands": "static-1.3955",
  "video-components-external": "static-1.12438",
  "trellis-story-utils": "static-1.4976",
  "ui-addon-react-router-dom": "static-1.10002",
  "content-media-capture": "static-1.5802",
  "knowledge-content-types": "static-1.8763",
  "ui-addon-emoji-picker": "static-1.10341",
  "ui-business-units-lib": "static-1.9573",
  "ui-shepherd-react": "static-3.10756",
  "hub-http-contrib": "static-1.3510",
  "ui-addon-sales-email": "static-1.5679",
  "commerce-tours-lib": "static-1.6869",
  "getting-started-shared-tasks": "static-1.19572",
  "sales-checkout-service-client": "static-1.3999",
  "merchandise-lib": "static-1.284",
  "getting-started-shared-tasks-store": "static-1.18690",
  "onboarding-tours-utils": "static-1.1477",
  "calling-error-reporting": "static-1.31810",
  "shared-worker-versioning": "static-1.11519",
  "calling-usage-tracker": "static-1.7017",
  "conversations-skeleton-state": "static-1.7608",
  "voice-sms-access-library": "static-1.2460",
  "commerce-permissions": "static-1.1262",
  "products-iframe-lib": "static-1.8914",
  "products-ui-components-shared-msw-handlers": "static-1.11294",
  "crm-index-associations-lib": "static-1.6927",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10995",
  "sales-views-client-types": "static-1.4735",
  "location-customization-utils-lib": "static-1.10427",
  "bark-lib": "static-1.17008",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6374",
  "react-codemirror": "static-1.11119",
  "data-agent-kit": "static-1.924",
  "data-agent-test-utils": "static-1.468",
  "data-agent-utils": "static-1.937",
  "data-token-picker": "static-1.17142",
  "fsm": "static-1.4235",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7282",
  "react-tinymce": "static-1.56277",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11058",
  "tinymce-config": "static-2.55403",
  "tinymce-plugins": "static-1.58517",
  "embedded-academy-lib": "static-1.16016",
  "hubs-service-types": "static-1.1746",
  "navigation-components": "static-1.19175",
  "nest": "static-1.713",
  "nudge-client-utils": "static-1.3429",
  "purchase-motions-api": "static-1.6639",
  "signup-constants": "static-1.19950",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5369",
  "reactive-lib": "static-1.1197",
  "simple-logging-lib": "static-1.3529",
  "nav-meta": "static-1.30812",
  "breeze-engine-core": "static-1.1471",
  "cms-field-types": "static-1.5288",
  "content-icons-ui": "static-1.2459",
  "integrations-lib": "static-1.17438",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.317",
  "unified-auth-core-lib": "static-1.1549",
  "social-insights-client-types": "static-1.22938",
  "outpost": "static-1.4606",
  "reporting-client-types": "static-1.2838",
  "signup-ui-url-generator": "static-2.8520",
  "developer-experience-shared-components": "static-1.11017",
  "immutable-less": "static-1.5130",
  "marketplace-ui-client-types": "static-1.18457",
  "marketplace-ui-common": "static-1.21050",
  "ui-addon-integrations-directory-panel": "static-2.8431",
  "ui-extensibility-client-types": "static-1.4393",
  "growth-data-modal": "static-1.6140",
  "growth-onboarding-next-action-utils": "static-1.2992",
  "onboarding-tours-client": "static-1.5625",
  "ui-shepherd-tracker": "static-1.8137",
  "ui-coaching-tips": "static-1.29586",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1171",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13606",
  "content-media-compositions": "static-2.17613",
  "media-bridge-lib": "static-1.19649",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4905",
  "calling-orchestration-schema": "static-1.37237",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16677",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.242",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57373",
  "interframe": "static-3.5219",
  "tinymce-data": "static-1.41488",
  "layout-dnd-components": "static-1.13236",
  "layout-dnd-utils": "static-1.12211",
  "ui-brand-identity-lib": "static-1.16959",
  "academy-common-lib": "static-1.15477",
  "nudge-custom-function-registry": "static-1.3186",
  "nudge-renderer-utils": "static-1.3505",
  "whisper-core-api": "static-1.7644",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14853",
  "integrations-tracking-lib": "static-1.6099",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4615",
  "ai-settings-ui-library": "static-1.8593",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1589",
  "onboarding-data-sync-lib": "static-1.2846",
  "growth-onboarding-next-action-components": "static-1.3020",
  "user-context-client": "static-1.4987",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9369",
  "ContentData": "static-1.69556",
  "layout-data-lib": "static-1.10536",
  "academy-service-client": "static-1.4170",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4874",
  "trellis-ecosystem": "static-1.7855",
  "wootric-nps": "static-1.7298",
  "universal-page-editor-lib": "static-1.3490",
  "settings-ui-lib": "static-1.13005",
  "simple-data-table": "static-1.3831",
  "meetings-connect-utils-lib": "static-1.8096",
  "advanced-menus-core": "static-1.15823",
  "advanced-menus-lib": "static-1.12573",
  "ExportDialog": "static-6.10852",
  "ui-memberships-settings-lib": "static-1.35203",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15822",
  "simple-menus-lib": "static-1.17339"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28713",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2021",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.511",
  "crm_data": "/crm_data/static-4.93214",
  "data-fetching-client": "/data-fetching-client/static-1.10118",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8755",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1780",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6070",
  "hs-test-utils": "/hs-test-utils/static-1.8516",
  "hub-http": "/hub-http/static-1.6684",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11965",
  "I18n": "/I18n/static-7.1708",
  "jasmine-runner": "/jasmine-runner/static-1.6929",
  "quartz": "/quartz/static-1.7660",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5658",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6102",
  "UIComponents": "/UIComponents/static-3.8911",
  "usage-tracker-public": "/usage-tracker-public/static-1.7613",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38062",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.636",
  "cssUtils": "/cssUtils/static-1.1100",
  "customer-data-objects": "/customer-data-objects/static-1.8182",
  "FireAlarmUi": "/FireAlarmUi/static-1.4867",
  "foundations-assets": "/foundations-assets/static-1.5363",
  "foundations-theming": "/foundations-theming/static-1.4966",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12272",
  "icons": "/icons/static-2.703",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3363",
  "property-translator": "/property-translator/static-1.5858",
  "quartz-config": "/quartz-config/static-1.1438",
  "quartz-core": "/quartz-core/static-1.6879",
  "quartz-i18n": "/quartz-i18n/static-1.1335",
  "quartz-routing": "/quartz-routing/static-1.1090",
  "quartz-tracking": "/quartz-tracking/static-1.1039",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17215",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10848",
  "rpc-client-utils": "/rpc-client-utils/static-1.5147",
  "sanitize-text": "/sanitize-text/static-1.8636",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5237",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11623",
  "ui-images": "/ui-images/static-2.1277",
  "usage-tracker-core": "/usage-tracker-core/static-1.7652",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3937",
  "quartz-webpack": "/quartz-webpack/static-1.3884",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.738",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "crm_universal": "/crm_universal/static-1.22733",
  "customer-data-email": "/customer-data-email/static-1.18649",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10309",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8398",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8241",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5024",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2682",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9905",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3095",
  "ui-fonts": "/ui-fonts/static-1.1227",
  "HeadJS": "/HeadJS/static-2.822",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3627",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4785",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6238",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5226",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20499",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19573",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11330",
  "crm-message-bus": "/crm-message-bus/static-1.44114",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13514",
  "customer-data-properties": "/customer-data-properties/static-1.53061",
  "growth-payments-core": "/growth-payments-core/static-1.26510",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9553",
  "usage-tracker": "/usage-tracker/static-1.7802",
  "usage-tracker-container": "/usage-tracker-container/static-1.7792",
  "sassPrefix": "/sassPrefix/static-1.366",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "foundations-theming-base": "/foundations-theming-base/static-1.3951",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3449",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.269",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.644",
  "quartz-auth": "/quartz-auth/static-1.1335",
  "quartz-head": "/quartz-head/static-1.1325",
  "quartz-test": "/quartz-test/static-1.1335",
  "trellis-components": "/trellis-components/static-1.3114",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5488",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.178",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.557",
  "chirp-fetch": "/chirp-fetch/static-1.2382",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4952",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5190",
  "sequences-lib": "/sequences-lib/static-1.8794",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5065",
  "FileManagerCore": "/FileManagerCore/static-1.40350",
  "FileManagerLib": "/FileManagerLib/static-1.40491",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5359",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.735",
  "timezone-utils": "/timezone-utils/static-2.5707",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "react-dnd-compat": "/react-dnd-compat/static-1.5087",
  "stylex-utils": "/stylex-utils/static-1.175",
  "trellis-theming": "/trellis-theming/static-1.1485",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2963",
  "hs-resources": "/hs-resources/static-1.667",
  "pulse": "/pulse/static-1.1125",
  "utility-belt": "/utility-belt/static-1.3015",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2026",
  "customer-data-associations": "/customer-data-associations/static-1.7816",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8529",
  "customer-data-tracking": "/customer-data-tracking/static-1.7348",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7370",
  "framework-data-table": "/framework-data-table/static-2.12846",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50056",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24213",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8253",
  "ui-addon-opt": "/ui-addon-opt/static-4.8888",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10028",
  "customer-data-rte": "/customer-data-rte/static-1.33908",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24851",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3536",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6542",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19287",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15851",
  "payment-link-components": "/payment-link-components/static-1.24464",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5582",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39177",
  "react-colorpicker": "/react-colorpicker/static-2.10687",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9101",
  "user-context": "/user-context/static-1.5531",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2034",
  "atom": "/atom/static-1.5550",
  "reference-resolvers": "/reference-resolvers/static-1.8661",
  "calling-global-api": "/calling-global-api/static-1.66205",
  "calling-internal-common": "/calling-internal-common/static-1.31803",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67587",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59879",
  "commerce-products-lib": "/commerce-products-lib/static-1.10927",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4763",
  "crm-links": "/crm-links/static-1.6790",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10239",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "formula-editor": "/formula-editor/static-1.15018",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1109",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4283",
  "property-value-citations": "/property-value-citations/static-1.3675",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8591",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.482",
  "smart-property-lib": "/smart-property-lib/static-1.8666",
  "tiered-pricing": "/tiered-pricing/static-1.2286",
  "topics-actions-lib": "/topics-actions-lib/static-1.661",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1395",
  "trial-components-library": "/trial-components-library/static-1.14383",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "laboratory-lib": "/laboratory-lib/static-3.7624",
  "onboarding-scopes": "/onboarding-scopes/static-1.6930",
  "seat-types-lib": "/seat-types-lib/static-1.1060",
  "magpie-lib": "/magpie-lib/static-1.5909",
  "navigation-messaging": "/navigation-messaging/static-1.8502",
  "ts-schema": "/ts-schema/static-1.4395",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10912",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10910",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8651",
  "audio-components": "/audio-components/static-1.6577",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.972",
  "ContentUtils": "/ContentUtils/static-1.69481",
  "copilot-toolkit": "/copilot-toolkit/static-1.12157",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30068",
  "FileManagerImages": "/FileManagerImages/static-1.38002",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4619",
  "ui-universal-auth": "/ui-universal-auth/static-1.9753",
  "urlinator": "/urlinator/static-1.4992",
  "video-components": "/video-components/static-1.14440",
  "video-data-lib": "/video-data-lib/static-1.36096",
  "video-embed": "/video-embed/static-1.36930",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.818",
  "trellis-migration-context": "/trellis-migration-context/static-1.58",
  "event-emitter": "/event-emitter/static-1.1439",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.489",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.628",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7275",
  "persist-promise": "/persist-promise/static-1.4183",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13654",
  "reporting-data": "/reporting-data/static-1.69361",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.440",
  "purchase-motions-components": "/purchase-motions-components/static-1.6636",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7058",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5561",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23907",
  "content-assistance-lib": "/content-assistance-lib/static-1.8429",
  "draft-content-plugins": "/draft-content-plugins/static-1.29164",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22365",
  "rich-text-lib": "/rich-text-lib/static-1.20562",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2193",
  "poll-commands": "/poll-commands/static-1.3955",
  "video-components-external": "/video-components-external/static-1.12438",
  "trellis-story-utils": "/trellis-story-utils/static-1.4976",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10002",
  "content-media-capture": "/content-media-capture/static-1.5802",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10341",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9573",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10756",
  "hub-http-contrib": "/hub-http-contrib/static-1.3510",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5679",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6869",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19572",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3999",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18690",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "calling-error-reporting": "/calling-error-reporting/static-1.31810",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11519",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7017",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2460",
  "commerce-permissions": "/commerce-permissions/static-1.1262",
  "products-iframe-lib": "/products-iframe-lib/static-1.8914",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11294",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6927",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10995",
  "sales-views-client-types": "/sales-views-client-types/static-1.4735",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10427",
  "bark-lib": "/bark-lib/static-1.17008",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6374",
  "react-codemirror": "/react-codemirror/static-1.11119",
  "data-agent-kit": "/data-agent-kit/static-1.924",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.468",
  "data-agent-utils": "/data-agent-utils/static-1.937",
  "data-token-picker": "/data-token-picker/static-1.17142",
  "fsm": "/fsm/static-1.4235",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-tinymce": "/react-tinymce/static-1.56277",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11058",
  "tinymce-config": "/tinymce-config/static-2.55403",
  "tinymce-plugins": "/tinymce-plugins/static-1.58517",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16016",
  "hubs-service-types": "/hubs-service-types/static-1.1746",
  "navigation-components": "/navigation-components/static-1.19175",
  "nest": "/nest/static-1.713",
  "nudge-client-utils": "/nudge-client-utils/static-1.3429",
  "purchase-motions-api": "/purchase-motions-api/static-1.6639",
  "signup-constants": "/signup-constants/static-1.19950",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5369",
  "reactive-lib": "/reactive-lib/static-1.1197",
  "simple-logging-lib": "/simple-logging-lib/static-1.3529",
  "nav-meta": "/nav-meta/static-1.30812",
  "breeze-engine-core": "/breeze-engine-core/static-1.1471",
  "cms-field-types": "/cms-field-types/static-1.5288",
  "content-icons-ui": "/content-icons-ui/static-1.2459",
  "integrations-lib": "/integrations-lib/static-1.17438",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.317",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1549",
  "social-insights-client-types": "/social-insights-client-types/static-1.22938",
  "outpost": "/outpost/static-1.4606",
  "reporting-client-types": "/reporting-client-types/static-1.2838",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11017",
  "immutable-less": "/immutable-less/static-1.5130",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8431",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4393",
  "growth-data-modal": "/growth-data-modal/static-1.6140",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2992",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8137",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29586",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1171",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13606",
  "content-media-compositions": "/content-media-compositions/static-2.17613",
  "media-bridge-lib": "/media-bridge-lib/static-1.19649",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4905",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37237",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16677",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.242",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57373",
  "interframe": "/interframe/static-3.5219",
  "tinymce-data": "/tinymce-data/static-1.41488",
  "layout-dnd-components": "/layout-dnd-components/static-1.13236",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12211",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16959",
  "academy-common-lib": "/academy-common-lib/static-1.15477",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3186",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3505",
  "whisper-core-api": "/whisper-core-api/static-1.7644",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14853",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6099",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4615",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8593",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1589",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2846",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3020",
  "user-context-client": "/user-context-client/static-1.4987",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "ContentData": "/ContentData/static-1.69556",
  "layout-data-lib": "/layout-data-lib/static-1.10536",
  "academy-service-client": "/academy-service-client/static-1.4170",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4874",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7855",
  "wootric-nps": "/wootric-nps/static-1.7298",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3490",
  "settings-ui-lib": "/settings-ui-lib/static-1.13005",
  "simple-data-table": "/simple-data-table/static-1.3831",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8096",
  "advanced-menus-core": "/advanced-menus-core/static-1.15823",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12573",
  "ExportDialog": "/ExportDialog/static-6.10852",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35203",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15822",
  "simple-menus-lib": "/simple-menus-lib/static-1.17339"
}
};
